module.exports = __webpack_public_path__ + "static/the-switch-product-apprehension-12e199419207a1a88998fb2c8ffdd5dd.jpg";